/*
 * @Autor: fengqi
 * @Date: 2019-10-11 10:40:59
 * @LastEditors: fengqi
 * @LastEditTime: 2019-10-12 10:58:06
 */
const api = {
  scanCard: {
    method: 'POST',
    desc: '扫码领卡券-H5页',
    path: 'api/v1.2/scan-card/html/info'
  },
  scanReceive: {
    method: 'POST',
    desc: 'H5领取卡券',
    path: 'api/v1.2/scan-card/html/receive'
  }
}

export default api
